import React, { useState } from "react";
import AppStore from "../../Images/AppStore.png";
import PlayStore from "../../Images/PlayStore.png";

const AppLinkPage = () => {
  const [loading, setLoading] = useState({
    playstore: false,
    appstore: false
  });

  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.housekeeper.app";
  const appStoreUrl = "https://apps.apple.com/gb/app/housekeeper-host/id6747610479";

  const handleStoreClick = (storeType) => {
    setLoading(prev => ({
      ...prev,
      [storeType]: true
    }));

    setTimeout(() => {
      if (storeType === 'playstore') {
        window.open(playStoreUrl, '_blank');
      } else if (storeType === 'appstore') {
        window.open(appStoreUrl, '_blank');
      }

      setLoading(prev => ({
        ...prev,
        [storeType]: false
      }));
    }, 1000);
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="flex lg:flex-row flex-col items-center justify-center h-fit mt-10">
      <div className="lg:w-1/2 bg-[#FFF5CE] md:p-12 p-4 flex flex-col items-center justify-center relative">

        <button
          onClick={handleGoBack}
          className="absolute top-4 left-4 flex items-center text-gray-600 hover:text-gray-800 transition-colors duration-200 mb-4"
        >
          <svg
            className="w-4 h-4 "
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          {/* Back */}
        </button>

        <h2 className="text-3xl font-bold items-center justify-center mb-6 mt-4">App Link</h2>
        <div className="xl:space-y-4 lg:space-y-8 space-y-4 w-full max-w-md">

          <div className="flex flex-col items-center">
            <p className="text-sm mt-6 text-center font-medium mb-2">
              Play Store App Link
            </p>
            <button
              onClick={() => handleStoreClick('playstore')}
              disabled={loading.playstore}
              className={`h-[50px] bg-white rounded font-medium flex items-center justify-center hover:bg-gray-100 transition-all duration-300  relative overflow-hidden ${loading.playstore ? 'opacity-70 scale-95' : ''
                }`}
            >
              {loading.playstore ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-600"></div>
                  <span className="ml-2">Loading...</span>
                </div>
              ) : (
                <img
                  src={PlayStore}
                  alt="Get on Google Play"
                  className="w-full h-full transition-transform duration-200 hover:scale-105"
                />
              )}
            </button>
          </div>

          <div className="flex flex-col items-center">
            <p className="text-sm mt-6 text-center font-medium mb-2">
              App Store Link
            </p>
            <button
              onClick={() => handleStoreClick('appstore')}
              disabled={loading.appstore}
              className={`h-[50px] bg-white rounded font-medium flex items-center justify-center hover:bg-gray-100 transition-all duration-300  relative overflow-hidden ${loading.appstore ? 'opacity-70 scale-95' : ''
                }`}
            >
              {loading.appstore ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-600"></div>
                  <span className="ml-2">Loading...</span>
                </div>
              ) : (
                <img
                  src={AppStore}
                  alt="Download on App Store"
                  className="w-full h-full transition-transform duration-200 hover:scale-105"
                />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppLinkPage;